import type { SystemMessage } from "./types";
import { Config } from "./config";
import { isServer } from "./utils";
import { defineNuxtPlugin, useBroadcasting, useVersionCheck } from "#imports";

export default defineNuxtPlugin({
  name: "system-messages",
  parallel: true,
  setup(nuxtApp) {
    if (isServer()) return;

    const { listenEvents } = useBroadcasting();
    const { checkVersion } = useVersionCheck();

    const handleSystemMessage = async (message: SystemMessage) => {
      switch (message.type) {
        case "force-refresh":
          window.location.reload();
          break;

        case "version-check":
          if (!message.payload.targetVersion) {
            return;
          }

          if (message.payload.targetVersion === "server") {
            await checkVersion();
            return;
          }

          if (message.payload.targetVersion !== window.__VERSION__) {
            window.location.reload();
          }
          break;
      }
    };

    const initializeSystemMessages = async () => {
      try {
        await listenEvents(
          Config.SYSTEM_CHANNEL,
          [Config.SYSTEM_MESSAGE_EVENT],
          handleSystemMessage,
        );
      } catch (error) {
        window.console.error("[System Messages] Failed to subscribe:", error);
      }
    };

    nuxtApp.hook("app:mounted", () => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          initializeSystemMessages();
        });
      } else {
        setTimeout(() => {
          initializeSystemMessages();
        }, 1000);
      }
    });
  },
});
